import api from "../../services/api";
import gridClientBase from "../../components/gridClientComponentBase";
import cellTemplate from "../../components/grid/cellTemplate/cellTemplate.vue";
import headerTemplate from "../../components/grid/headerTemplate/headerTemplate.vue";
import moment from "moment";
import formatcoords from "formatcoords";
import helpers from "../../shared/fleetbox-helpers";
import reverseGeocoding from "./reverseGeocoding.vue";
import { bus } from "../../main";
import { mapGetters } from "vuex";

export default {
	extends: gridClientBase,
	components: {
		"reverse-geocoding": reverseGeocoding
	},
	props: {
		data: Array,
		vehicleItemsFilter: Array,
		vehicleSelectedFilter: Array,
		driverItemsFilter: Array,
		driversSelectedFilter: Array,
		statusFilter: Array,
		vehicleIdFilterField: String
	},
	data: function() {
		return {
			notHasTripsDataPermission: true,
			statusSelectedFilter: [],
			groupsSelectedFilter: [],
			search: "",
			sortStates: [
				{
					name: this.vehicleIdFilterField,
					dir: ""
				},
				{
					name: "vehicle_name",
					dir: ""
				},
				{
					name: "status",
					dir: ""
				}
			],
			totalItems: 0
		};
	},

	created() {
		var self = this;

		if (this.scopes && this.scopes.length > 0) {
			this.notHasTripsDataPermission =
				this.scopes.some(item => {
					return item == "TRIPS_DATA";
				}) == false;
		}

		this.take = 5;

		this.hasSelectedMode = true;
		this.items = this.data;

		//Inizialize Filters if already presents
		this.inizializeFilters();

		bus.$on("marker-click", self.markerClickHandler.bind(self));
		bus.$on("filter-head-change", self.onFilterHeadChange.bind(self));
		bus.$on("on-ht-grid-filter-changed", self.onHeaderHorizontalTableFilterChanged.bind(self));
	},
	beforeDestroy() {
		var self = this;
		bus.$off("marker-click");
		bus.$off("filter-head-change");
		bus.$off("on-ht-grid-filter-changed");
	},
	watch: {
		data: {
			handler() {
				var sortByCol = [];
				var sortByDir = [];
				var sorted = false;
				this.sortStates.forEach(item => {
					if (item.dir) {
						sorted = true;
						sortByCol.push(item.name);
						sortByDir.push(item.dir);
					}
				});

				if (sorted == false) {
					sortByCol.push("last_event_date");
					sortByDir.push("desc");
				}

				this.items = this._.orderBy(this.data, sortByCol, sortByDir);
				this.totalItems = this.items.length;
			},
			deep: true
		},
		gridData() {
			if (this.gridData && this.gridData.length) {
				bus.$emit("set-address-to", { source: "verticalTable", items: this.gridData });
			}
		}
	},
	/* metodi */
	methods: {
		onHeaderHorizontalTableFilterChanged(filters) {
			if (!this._.isUndefined(filters) && !this._.isNull(filters)) this.columnFilters = filters;
		},
		onFilterHeadChange(filters) {
			if (filters.length > 0) {
				for (var i = 0; i < filters.length; i++) {
					let e = filters[i];
					if (e.filterItemsSelected.length > 0) {
						var filterToApply = {
							field: e.field,
							filterType: e.filterType,
							filterItemsSelected: e.filterItemsSelected
						};

						this.filterHandler(filterToApply, true);
					} else {
						this.removeFilter({
							field: e.field
						});
					}
				}
			}
		},
		goToTripsData(number_plate, pathId, statusDate, vehicle_id) {
			if (this.notHasTripsDataPermission == false) {
				var startDateFilter = null;

				var lastStatusDate = moment(statusDate);
				var now = moment();
				var timeToOff = "";

				var diff = now.diff(lastStatusDate, "days");
				if (diff == 0) {
					this.$router.push({
						name: "TRIPS_DATA",
						query: {
							vehicleId: number_plate,
							pathId: pathId,
							code: vehicle_id
						}
					});
				} else {
					startDateFilter = lastStatusDate.startOf("day");
					this.$router.push({
						name: "TRIPS_DATA",
						query: {
							vehicleId: number_plate,
							pathId: pathId,
							startDay: startDateFilter.utc().format()
						}
					});
				}
			}
		},
		orderByLink(column) {
			switch (column) {
				case "number_plate":
					var actualNumberPlateSort = this.sortStates[0];

					if (actualNumberPlateSort.dir == "asc") {
						actualNumberPlateSort.dir = "desc";
					} else if (actualNumberPlateSort.dir == "desc") {
						actualNumberPlateSort.dir = "";
					} else {
						actualNumberPlateSort.dir = "asc";
					}
					break;

				case "vehicle_name":
					var actualNumberPlateSort = this.sortStates[1];

					if (actualNumberPlateSort.dir == "asc") {
						actualNumberPlateSort.dir = "desc";
					} else if (actualNumberPlateSort.dir == "desc") {
						actualNumberPlateSort.dir = "";
					} else {
						actualNumberPlateSort.dir = "asc";
					}
					break;

				case "status":
					var actualNumberPlateSort = this.sortStates[2];

					if (actualNumberPlateSort.dir == "asc") {
						actualNumberPlateSort.dir = "desc";
					} else if (actualNumberPlateSort.dir == "desc") {
						actualNumberPlateSort.dir = "";
					} else {
						actualNumberPlateSort.dir = "asc";
					}
					break;

				default:
					break;
			}

			var sortByCol = [];
			var sortByDir = [];

			var sorted = false;
			this.sortStates.forEach(item => {
				if (item.dir) {
					sorted = true;
					sortByCol.push(item.name);
					sortByDir.push(item.dir);
				}
			});

			if (sorted == false) {
				sortByCol.push("last_event_date");
				sortByDir.push("desc");
			}

			this.items = this._.orderBy(this.data, sortByCol, sortByDir);
		},
		searchClick() {
			alert("azione da definire");
		},
		onUpdateGeocodingAddress(e) {
			this.$emit("update-address-data", {
				id: e.id,
				address: e.address
			});
		},
		inizializeFilters() {
			if (this.vehicleSelectedFilter.length > 0) {
				var filtersToAdd = {
					field: this.vehicleIdFilterField,
					type: "multiselect",
					filter: {
						logic: "or",
						filters: []
					}
				};

				for (var i = 0; i < this.vehicleSelectedFilter.length; i++) {
					var f = this.vehicleSelectedFilter[i];
					filtersToAdd.filter.filters.push({
						field: this.vehicleIdFilterField,
						operator: "contains",
						value: f
					});
				}

				this.columnFilters.push(filtersToAdd);
			}
			if (this.driversSelectedFilter.length > 0) {
				var filtersToAdd = {
					field: "driver_name",
					type: "multiselect",
					filter: {
						logic: "or",
						filters: []
					}
				};

				for (var i = 0; i < this.driversSelectedFilter.length; i++) {
					var f = this.driversSelectedFilter[i];
					filtersToAdd.filter.filters.push({
						field: "driver_name",
						operator: "contains",
						value: f
					});
				}

				this.columnFilters.push(filtersToAdd);
			}
		},
		markerClickHandler(e) {
			if (e && e.marker) {
				var itemToSelect = this._.find(this.items, function(x) {
					return x.id === e.marker.id;
				});

				var showItemIndex = this.itemToReturnIfIsInEditMode.findIndex(function(x) {
					return x.id == itemToSelect.id;
				});

				var pageSize = this.take;
				var page = parseInt(showItemIndex / pageSize);

				this.skip = this.take * page;


				if (itemToSelect) {
					this.selectRow(itemToSelect);
				}
			}
		},
		formattedCoordinates(lat, lon) {
			return helpers.formatCoordinate(lat, "lat") + ", " + helpers.formatCoordinate(lon, "lon");
		},
		getStatusLabel(status) {
			switch (status) {
				case "active":
					return "MOVIMENTO";
					break;
				case "off":
					return "FERMO";
					break;

				default:
					return "INATTIVO";
					break;
			}
		},
		getTimeFromNow(status_date) {
			var lastStatusDate = moment(status_date);
			var now = moment();
			var timeToOff = "";

			var diff = now.diff(lastStatusDate, "days");
			timeToOff = `${diff} GIORNO/I`;
			if (diff == 0) {
				diff = now.diff(lastStatusDate, "hours");
				timeToOff = `${diff} ORA/E`;
			}
			if (diff == 0) {
				diff = now.diff(lastStatusDate, "minutes");
				timeToOff = `${diff} MINUTO/I`;
			}
			if (diff == 0) {
				diff = now.diff(lastStatusDate, "seconds");
				timeToOff = `${diff} SECONDO/I`;
			}

			return timeToOff;
		},
		getStatusIcon(status) {
			switch (status) {
				case "active":
					return "green";
					break;
				case "off":
					return "orange";
					break;

				default:
					return "red";
					break;
			}
		}
	},
	computed: {
		...mapGetters(["settings", "scopes"]),
		columns: function() {
			return [
				{
					field: "position",
					title: "posizione",
					className: "",
					headerCell: "myHeaderTemplate",
					cell: "myPositionAddressCellTemplate",
					filterable: false
				},
				{
					field: "status",
					title: "stato",
					width: "150",
					headerCell: "myHeaderTemplate",
					filterable: true,
					cell: "myStatusCellTemplate"
				}
			];
		},
		vehicleIdFilterFieldString() {
			return this.vehicleIdFilterField == "number_plate" ? "TARGA" : "CODICE";
		}
	}
};
